import React, { useState, useEffect } from "react";
import "./process.css";
import { withTranslation } from "react-i18next";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import SkeletonProcess from "./components/SkeletonProcess";
import { routeConstant } from "../../routing";
import BtnOutline from "../../components/button/BtnOutline";
import { useDispatch, useSelector } from "react-redux";
import { getShipments } from "../../store/redux/actions/ShipmentAction";
import { basename } from "../../Config";
import Nodata from "../../components/Nodata";
import { CircularProgress } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { toast } from "react-hot-toast";
import { useRef } from "react";
import urlResolver from "../../utils/urlResolver";

function Process(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { shipment, loading, isLoadMore, error, list, totalCount } =
    useSelector((state) => {
      return state.shipments;
    });
  const { selectedOrgCodes } = useSelector((state) => state.org || {});
  console.log("selectedOrgCodes", selectedOrgCodes);

  const controllerRef = useRef(null);
  const isInitialLoad = useRef(false);
  const TotalCount = useRef(null);
  const searchRef = useRef(null);
  const search2Ref = useRef(null);

  const [nav, setNav] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [shipmentList, setShipmentList] = useState([]);
  const [shipmentData, setShipmentData] = useState([]);
  const [search, setSearch] = useState({
    type: "",
    value: "",
  });
  const [placeholderText, setPlaceholderText] = useState("Search");
  const [search2, setSearch2] = useState({
    type: "",
    value: "",
  });
  const [placeholderText2, setPlaceholderText2] = useState("Search");
  const [advancesearch, setAdvancesearch] = useState({
    sort: "LastEditedDateTime",
    order: "DESC",
    mode: "",
    status: "",
    direction: "",
    activeA: false,
    activeS: false,
    activeR: false,
    activeP: false,
    activeL: false,
    activeAr: false,
    activeI: false,
    activeE: false,
  });
  const [count, setCount] = useState(0);
  const [showstatus, setShowstatus] = useState("");
  const [activeFilter, setActiveFilter] = useState("");
  const [checkAbort, setCheckAbort] = useState(false);
  const [selectedListItem, setSelectedListItem] = useState(0);
  const [showMore, setShowMore] = useState(false);

  const { t } = props;
  const controller = new AbortController();
  const signal = controller.signal;

  const buildFieldsFrom = (s) => {
    if (!s || !s.type) return {};
    const v = s.value || "";
    switch (s.type) {
      case "ShipmentId":
        return { ShipmentId: v };
      case "Origin":
        return { OriginPortCode: v };
      case "Destination":
        return { DestinationPortCode: v };
      case "Origin Port":
        return { OriginPortName: v };
      case "Destination Port":
        return { DestinationPortName: v };
      case "CNPJ":
        return { CNPJ: v };
      case "Ship":
        return { Ship: v };
      case "PO Number":
        return { PONumber: v };
      case "ShipperName":
        return { ShipperName: v };
      case "ConsigneeName":
        return { ConsigneeName: v };
      case "Waybill":
        return { Waybill: v };
      case "Ref":
      case "ShipperReff":
        return { SearchField: v };
      default:
        return {};
    }
  };
  const getOrgCodeField = () => {
    if (!selectedOrgCodes || selectedOrgCodes.length === 0) return {};
    return {
      OrgCode: Array.isArray(selectedOrgCodes)
        ? selectedOrgCodes.join(",")
        : selectedOrgCodes,
    };
  };

  const resetSearch = () => {
    setSearch({
      type: "",
      value: "",
    });
    setSearch2({
      type: "",
      value: "",
    });
  };

  const fetchShipments = (
    page,
    searchPayload,
    advSearch,
    status = "",
    isSearch = 0,
  ) => {
    // cancel previous request
    controllerRef.current?.abort();
    // create new controller
    controllerRef.current = new AbortController();

    const orgCodeValue = Array.isArray(selectedOrgCodes)
      ? selectedOrgCodes.join(",")
      : selectedOrgCodes || "";

    dispatch(
      getShipments(
        page,
        searchPayload,
        advSearch,
        status,
        isSearch,
        controllerRef.current.signal,
        orgCodeValue,
      ),
    );
  };

  useEffect(() => {
    if (isInitialLoad.current) return;

    if (location.pathname === "/process" && location.state === null) {
      isInitialLoad.current = true;
      console.log("<----Intial Load1--->");
      fetchShipments(0, search, advancesearch, "", 0);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === "/process/details" && !isInitialLoad.current) {
      isInitialLoad.current = true;
      console.log("<----Intial Load2--->");
      fetchShipments(0, search, advancesearch, "", 0);
    }
  }, []);

  useEffect(() => {
    console.log("selectedOrgCodes in useEffect", selectedOrgCodes);
    // if (!isInitialLoad.current) return;
    resetSearch();
    setCount(0);
    setSelectedListItem(0);

    fetchShipments(0, search, advancesearch, showstatus, 0);
  }, [selectedOrgCodes]);

  useEffect(() => {
    setShipmentData(shipment);
    setShipmentList(list);
  }, [shipment]);

  useEffect(() => {
    let isSearch = 0;

    if (location?.state?.from === "order") {
      fetchShipments(
        count,
        {
          type: "ShipmentId",
          value: location.state.item?.ShipmentID,
        },
        advancesearch,
        "",
        0,
      );
    }

    if (
      location?.state?.from === "onClickSearchProcess" ||
      location?.state?.from === "onEnterSearchProcess"
    ) {
      isSearch = search.type ? 1 : 0;
      fetchShipments(0, search, advancesearch, "", isSearch);
    }

    // if the user navigates from 48 hours dashboard list
    if (location?.state?.from === "dashboardlist") {
      let temp = {
        type: "ShipmentId",
        value: location?.state?.item?.ShipmentID,
      };
      fetchShipments(count, temp, advancesearch, "", isSearch, signal);
    }

    // if the user navigates from dashboard seemore button in status
    if (location?.state?.from === "dashboardseemore") {
      // setShowstatus(location.state.status);
      const dashboardStatus = location.state?.status || "";
      setShowstatus((prev) => prev || dashboardStatus);

      fetchShipments(count, search, advancesearch, dashboardStatus, 0);
    }
    // TODO: Bring back the notification based fetching when the notification component is ready and integrated

    if (showMore) {
      const safeStatus = showstatus || location?.state?.status || "";
      console.log("<----showmore--->");
      fetchShipments(count, search, advancesearch, safeStatus, 0);
      setShowMore(false);
    }
  }, [count]);

  // Re-fetch shipments when selected organization codes change (staged in header and saved)

  // useEffect(() => {
  //   if (!selectedOrgCodes) return;

  //   let orgs = Array.isArray(selectedOrgCodes)
  //     ? selectedOrgCodes.join(",")
  //     : selectedOrgCodes;
  //   const safeStatus = showstatus || location?.state?.status || "";
  //   console.log("<----Intial Load organization code--->");
  //   fetchShipments(
  //     0,
  //     { fields: { OrgCode: orgs } },
  //     advancesearch,
  //     safeStatus,
  //     0,
  //   );
  // }, [selectedOrgCodes]);

  const closeNav = () => {
    if (nav) {
      setDisabled(false);
      setNav(false);
    } else {
      setNav(true);
      setDisabled(true);
      // setSearch({
      //   type: "",
      //   value: "",
      // });
    }
  };
  useEffect(() => {
    return () => {
      controllerRef.current?.abort();
    };
  }, []);

  const handleCardClick = (item, index) => {
    setSelectedListItem(index ?? 0);
    const path = `${routeConstant.PROCESS}/${routeConstant.PROCESSDETAILS}`;
    navigate(path, {
      state: { item: item },
    });
  };

  const handleShowMore = () => {
    const nextCount = count + 1;
    setCount(nextCount);

    let payloadSearch = search;

    if (search?.type && search2?.type) {
      payloadSearch = {
        fields: {
          ...buildFieldsFrom(search),
          ...buildFieldsFrom(search2),
          ...getOrgCodeField(),
        },
      };
    } else if (!search?.type && search2?.type) {
      payloadSearch = {
        fields: {
          ...buildFieldsFrom(search2),
          ...getOrgCodeField(),
        },
      };
    } else {
      payloadSearch = {
        fields: {
          ...buildFieldsFrom(search),
          ...getOrgCodeField(),
        },
      };
    }

    const isSearchShowMore =
      payloadSearch?.fields && Object.keys(payloadSearch.fields).length ? 1 : 0;

    fetchShipments(
      nextCount,
      payloadSearch,
      advancesearch,
      showstatus,
      isSearchShowMore,
      signal,
    );
  };

  useEffect(() => {
    if (shipment.length) handleCardClick(shipment[0]);
    else handleCardClick({ status: false });
  }, [shipment]);

  const onSearch = (e) => {
    if (e.key !== "Enter") return;

    // quick ShipmentID search when no type selected but value looks like an ID
    if (search.type === "" && search.value && search.value.length > 1) {
      const path = `${routeConstant.PROCESS}/${routeConstant.PROCESSDETAILS}`;
      navigate(path, {
        state: {
          item: {
            ShipmentID: search.value,
          },
          from: "onEnterSearchProcess",
        },
      });
      setSelectedListItem(null);
      return;
    }

    // If neither search has usable input, show error (same behaviour as button)
    const hasSearch1 = search.type && search.value;
    const hasSearch2 = search2.type && search2.value;
    // if a type is selected without a value, require the value
    if (search.type && !search.value) {
      toast.error("Please enter a value for the selected field");
      return;
    }
    if (search2.type && !search2.value) {
      toast.error("Please enter a value for the selected field");
      return;
    }
    if (!hasSearch1 && !hasSearch2) {
      toast.error("Please select both fields");
      return;
    }

    const isSearch = search.type !== "" ? 1 : 0;
    const path = `${routeConstant.PROCESS}/${routeConstant.PROCESSDETAILS}`;
    navigate(path, {
      state: {
        from: "onEnterSearchProcess",
      },
    });

    if (search.type && search2.type) {
      const fields = {
        ...buildFieldsFrom(search),
        ...buildFieldsFrom(search2),
      };
      fetchShipments(0, { fields }, advancesearch, "", isSearch, signal);
    } else if (hasSearch1) {
      fetchShipments(0, search, advancesearch, "", isSearch, signal);
    } else if (hasSearch2) {
      // if only second search has values, use it
      const isSearch2 = search2.type !== "" ? 1 : 0;
      fetchShipments(0, search2, advancesearch, "", isSearch2, signal);
    }
  };
  const onSearch2 = (e) => {
    if (e.key !== "Enter") return;

    // quick ShipmentID search when no type selected but value looks like an ID
    if (search2.type === "" && search2.value && search2.value.length > 1) {
      const path = `${routeConstant.PROCESS}/${routeConstant.PROCESSDETAILS}`;
      navigate(path, {
        state: {
          item: {
            ShipmentID: search2.value,
          },
          from: "onEnterSearchProcess",
        },
      });
      setSelectedListItem(null);
      return;
    }

    // If neither search has usable input, show error
    const hasSearch1 = search.type && search.value;
    const hasSearch2 = search2.type && search2.value;
    // if a type is selected without a value, require the value
    if (search.type && !search.value) {
      toast.error("Please enter a value for the selected field");
      return;
    }
    if (search2.type && !search2.value) {
      toast.error("Please enter a value for the selected field");
      return;
    }
    if (!hasSearch1 && !hasSearch2) {
      toast.error("Please select both fields");
      return;
    }

    const isSearch = search2.type !== "" ? 1 : 0;
    const path = `${routeConstant.PROCESS}/${routeConstant.PROCESSDETAILS}`;
    navigate(path, {
      state: {
        from: "onEnterSearchProcess",
      },
    });
    if (search.type && search2.type) {
      const fields = {
        ...buildFieldsFrom(search),
        ...buildFieldsFrom(search2),
      };
      fetchShipments(0, { fields }, advancesearch, "", isSearch, signal);
    } else if (hasSearch2) {
      fetchShipments(0, search2, advancesearch, "", isSearch, signal);
    } else if (hasSearch1) {
      const isSearch1 = search.type !== "" ? 1 : 0;
      fetchShipments(0, search, advancesearch, "", isSearch1, signal);
    }
  };
  const onClickSearch = () => {
    if (search.type && !search.value) {
      toast.error("Please enter a value for the selected field");
      return;
    }
    if (search2.type && !search2.value) {
      toast.error("Please enter a value for the selected field");
      return;
    }

    let isSearch = search.type !== "" ? 1 : 0;

    navigate(routeConstant.PROCESS, {
      state: { from: "onClickSearchProcess" },
    });

    if (search.type && search2.type) {
      const fields = {
        ...buildFieldsFrom(search),
        ...buildFieldsFrom(search2),
        ...getOrgCodeField(),
      };

      fetchShipments(0, { fields }, advancesearch, "", isSearch, signal);
    } else {
      fetchShipments(
        0,
        {
          fields: {
            ...buildFieldsFrom(search),
            ...getOrgCodeField(),
          },
        },
        advancesearch,
        "",
        isSearch,
        signal,
      );
    }
  };
  const onClickSearch2 = () => {
    if (search.type && !search.value) {
      toast.error("Please enter a value for the selected field");
      return;
    }
    if (search2.type && !search2.value) {
      toast.error("Please enter a value for the selected field");
      return;
    }

    let isSearch = search2.type !== "" ? 1 : 0;

    navigate(routeConstant.PROCESS, {
      state: { from: "onClickSearchProcess" },
    });

    if (search.type && search2.type) {
      const fields = {
        ...buildFieldsFrom(search),
        ...buildFieldsFrom(search2),
        ...getOrgCodeField(),
      };

      fetchShipments(0, { fields }, advancesearch, "", isSearch, signal);
    } else if (search2.type) {
      fetchShipments(
        0,
        {
          fields: {
            ...buildFieldsFrom(search2),
            ...getOrgCodeField(),
          },
        },
        advancesearch,
        "",
        isSearch,
        signal,
      );
    } else if (search.type) {
      fetchShipments(
        0,
        {
          fields: {
            ...buildFieldsFrom(search),
            ...getOrgCodeField(),
          },
        },
        advancesearch,
        "",
        isSearch,
        signal,
      );
    }
  };

  const handleClear = () => {
    const cleared = { type: "", value: "" };

    const curSearch = search || { type: "", value: "" };
    const curSearch2 = search2 || { type: "", value: "" };

    setSearch(cleared);

    const isSearch1Empty = !curSearch.type && !curSearch.value;
    const isSearch2Empty = !curSearch2.type && !curSearch2.value;

    // If both searches are empty
    if (isSearch1Empty && isSearch2Empty) {
      fetchShipments(
        count,
        {
          fields: {
            ...getOrgCodeField(),
          },
        },
        advancesearch,
        "",
        0,
        signal,
      );
      return;
    }

    // Preserve search2 if present
    const payloadFields = !isSearch2Empty
      ? {
          ...buildFieldsFrom(curSearch2),
          ...getOrgCodeField(),
        }
      : {
          ...getOrgCodeField(),
        };

    const isSearch =
      payloadFields && Object.keys(payloadFields).length > 0 ? 1 : 0;

    fetchShipments(
      count,
      { fields: payloadFields },
      advancesearch,
      "",
      isSearch,
      signal,
    );
  };

  const handleClear2 = () => {
    const cleared = { type: "", value: "" };

    const curSearch = search || { type: "", value: "" };
    const curSearch2 = search2 || { type: "", value: "" };

    setSearch2(cleared);

    const isSearch1Empty = !curSearch.type && !curSearch.value;
    const isSearch2Empty = !curSearch2.type && !curSearch2.value;

    // If both searches are empty
    if (isSearch1Empty && isSearch2Empty) {
      fetchShipments(
        count,
        {
          fields: {
            ...getOrgCodeField(),
          },
        },
        advancesearch,
        "",
        0,
        signal,
      );
      return;
    }

    // Preserve search1 if present
    const payloadFields = !isSearch1Empty
      ? {
          ...buildFieldsFrom(curSearch),
          ...getOrgCodeField(),
        }
      : {
          ...getOrgCodeField(),
        };

    const isSearch =
      payloadFields && Object.keys(payloadFields).length > 0 ? 1 : 0;

    fetchShipments(
      count,
      { fields: payloadFields },
      advancesearch,
      "",
      isSearch,
      signal,
    );
  };

  return (
    <>
      <div>
        {loading ? (
          <div
            style={{
              width: "calc(100% - 40px)",
              margin: "0 auto",
              paddingTop: "50px",
            }}
          >
            <SkeletonProcess />
          </div>
        ) : (
          <div
            style={{
              width: "calc(100% - 40px)",
              margin: "0 auto",
              paddingTop: "50px",
            }}
            className="container-fluid"
          >
            <div className="row ">
              <div
                className="col-12  col-lg-3 left-row-process"
                id="left-process-div"
              >
                <div className="card-head d-flex">
                  <div className="search-filter ">
                    <div className="select" style={{ marginLeft: "19px" }}>
                      <select
                        disabled={nav}
                        className="title-select text-ellipsis"
                        value={search2.type}
                        onChange={(event) => {
                          const obj = { ...search2 };
                          obj.type = event.target.value;
                          if (event.target.value === "Ref") {
                            setPlaceholderText2("HBL No | Shipment No | PO No");
                          } else if (event.target.value === "ShipperReff") {
                            setPlaceholderText2(
                              "HBL No | Shipment No | PO No | Shipper Ref #",
                            );
                          } else {
                            setPlaceholderText2("Search");
                          }
                          setSearch2(obj);
                          if (obj.type) search2Ref.current?.focus();
                        }}
                      >
                        <option value="" disabled selected hidden>
                          {t("Select")}
                        </option>
                        <option value="CNPJ" disabled={search.type === "CNPJ"}>
                          <span>{t("CNPJ")}</span>
                        </option>
                        <option
                          value="Origin Port"
                          disabled={search.type === "Origin Port"}
                        >
                          {t("Origin Name")}
                        </option>
                        <option
                          value="Destination Port"
                          disabled={search.type === "Destination Port"}
                        >
                          {t("Dest Name")}
                        </option>
                        <option
                          value="PO Number"
                          disabled={search.type === "PO Number"}
                        >
                          {t("PONumber")}
                        </option>
                        <option
                          value="ShipperName"
                          disabled={search.type === "ShipperName"}
                        >
                          {t("Shipper")}
                        </option>
                        <option
                          value="ConsigneeName"
                          disabled={search.type === "ConsigneeName"}
                        >
                          {t("Consignee")}
                        </option>
                        <option value="Ship" disabled={search.type === "Ship"}>
                          {t("Vessel")}
                        </option>
                        <option
                          value="ShipmentId"
                          disabled={search.type === "ShipmentId"}
                        >
                          Shipment #
                        </option>
                        <option
                          value="Waybill"
                          disabled={search.type === "Waybill"}
                        >
                          HBL/AWB
                        </option>
                        <option value="Ref" disabled={search.type === "Ref"}>
                          Ref #
                        </option>
                        {/* <option value="ShipperReff">Shipper Ref #</option> */}
                      </select>
                    </div>
                    <div className="search-div">
                      <input
                        ref={search2Ref}
                        disabled={nav || !search2.type}
                        className="input-search"
                        type="text"
                        placeholder={
                          placeholderText2 === "Search"
                            ? t(placeholderText2)
                            : placeholderText2
                        }
                        value={search2.value}
                        onKeyPress={(e) => onSearch2(e)}
                        onChange={(event) => {
                          const obj = { ...search2 };
                          obj.value = event.target.value;
                          setSearch2(obj);
                        }}
                      />
                      {search2.value.length ? (
                        <CloseOutlinedIcon
                          style={{ cursor: "pointer", marginLeft: "-20px" }}
                          onClick={() => {
                            handleClear2();
                          }}
                        />
                      ) : null}
                    </div>
                    <div className="filter-icon">
                      <SearchOutlinedIcon
                        onClick={() => {
                          onClickSearch2();
                        }}
                        className="search-icon"
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>
                  <div className="search-filter ">
                    <span
                      style={{
                        color: "var(--color-gray4)",
                        fontSize: "1.1rem",
                        marginTop: "2px",
                        fontFamily: "siena-light",
                      }}
                    >
                      and
                    </span>
                    <div className="select">
                      <select
                        disabled={nav}
                        className="title-select text-ellipsis"
                        value={search.type}
                        onChange={(event) => {
                          const obj = { ...search };
                          obj.type = event.target.value;
                          if (event.target.value === "Ref") {
                            setPlaceholderText("HBL No | Shipment No | PO No");
                          } else if (event.target.value === "ShipperReff") {
                            setPlaceholderText(
                              "HBL No | Shipment No | PO No | Shipper Ref #",
                            );
                          } else {
                            setPlaceholderText("Search");
                          }
                          setSearch(obj);
                          if (obj.type) searchRef.current?.focus();
                        }}
                      >
                        <option value="" disabled selected hidden>
                          {t("Select")}
                        </option>
                        <option value="CNPJ" disabled={search2.type === "CNPJ"}>
                          <span>{t("CNPJ")}</span>
                        </option>
                        <option
                          value="Origin Port"
                          disabled={search2.type === "Origin Port"}
                        >
                          {t("Origin Name")}
                        </option>
                        {/* <option value="Destination">
                          {t("Destination")}
                        </option>{" "} */}
                        <option
                          value="Destination Port"
                          disabled={search2.type === "Destination Port"}
                        >
                          {t("Dest Name")}
                        </option>
                        <option
                          value="PO Number"
                          disabled={search2.type === "PO Number"}
                        >
                          {t("PONumber")}
                        </option>
                        <option
                          value="ShipperName"
                          disabled={search2.type === "ShipperName"}
                        >
                          {t("Shipper")}
                        </option>
                        <option
                          value="ConsigneeName"
                          disabled={search2.type === "ConsigneeName"}
                        >
                          {t("Consignee")}
                        </option>
                        <option value="Ship" disabled={search2.type === "Ship"}>
                          {t("Vessel")}
                        </option>
                        <option
                          value="ShipmentId"
                          disabled={search2.type === "ShipmentId"}
                        >
                          Shipment #
                        </option>
                        <option
                          value="Waybill"
                          disabled={search2.type === "Waybill"}
                        >
                          HBL/AWB
                        </option>
                        <option value="Ref" disabled={search2.type === "Ref"}>
                          Ref #
                        </option>
                        {/* <option value="ShipperReff">Shipper Ref #</option> */}
                      </select>
                    </div>
                    <div className="search-div">
                      <input
                        ref={searchRef}
                        disabled={nav || !search.type}
                        className="input-search"
                        type="text"
                        placeholder={
                          placeholderText === "Search"
                            ? t(placeholderText)
                            : placeholderText
                        }
                        value={search.value}
                        onKeyPress={(e) => onSearch(e)}
                        onChange={(event) => {
                          const obj = { ...search };
                          obj.value = event.target.value;
                          setSearch(obj);
                        }}
                      />
                      {search.value.length ? (
                        <CloseOutlinedIcon
                          style={{ cursor: "pointer", marginLeft: "-20px" }}
                          onClick={() => {
                            handleClear();
                          }}
                        />
                      ) : null}
                    </div>
                    <div className="filter-icon">
                      <TuneOutlinedIcon
                        className="filter-sec"
                        style={{ cursor: "pointer" }}
                        onClick={() => closeNav()}
                      />
                    </div>
                  </div>
                  {nav ? (
                    <div className="sort-box">
                      <div className="div-sort" value={advancesearch.sort}>
                        <p>{t("SortBy")} :</p>
                        <div className="sort-option-div ">
                          <div className="d-flex" id="radiodiv">
                            <input
                              type="radio"
                              id="CreatedDateTime"
                              onChange={(event) => {
                                const obj = { ...advancesearch };
                                obj.sort = event.target.value;

                                setAdvancesearch(obj);
                              }}
                              checked={
                                advancesearch.sort === "CreatedDateTime"
                                  ? true
                                  : false
                              }
                              value="CreatedDateTime"
                            />
                            <label
                              htmlFor="CreatedDateTime"
                              style={{
                                color:
                                  advancesearch.sort === "CreatedDateTime"
                                    ? "#120b5e"
                                    : "",
                              }}
                            >
                              {t("Created")}
                            </label>
                          </div>
                          <div className="d-flex" id="radiodiv">
                            <input
                              type="radio"
                              id="LastEditedDateTime"
                              onChange={(event) => {
                                const obj = { ...advancesearch };
                                obj.sort = event.target.value;

                                setAdvancesearch(obj);
                              }}
                              checked={
                                advancesearch.sort === "LastEditedDateTime"
                                  ? true
                                  : false
                              }
                              value="LastEditedDateTime"
                            />
                            <label
                              htmlFor="LastEditedDateTime"
                              style={{
                                color:
                                  advancesearch.sort === "LastEditedDateTime"
                                    ? "#120b5e"
                                    : "",
                              }}
                            >
                              {t("LastUpdated")}
                            </label>
                          </div>
                          <div className="d-flex" id="radiodiv">
                            <input
                              type="radio"
                              id="ETA"
                              onChange={(event) => {
                                const obj = { ...advancesearch };
                                obj.sort = event.target.value;

                                setAdvancesearch(obj);
                              }}
                              checked={
                                advancesearch.sort === "ETA" ? true : false
                              }
                              value="ETA"
                            />
                            <label
                              htmlFor="ETA"
                              style={{
                                color:
                                  advancesearch.sort === "ETA" ? "#120b5e" : "",
                              }}
                            >
                              {t("ETA")}
                            </label>
                          </div>
                          <div className="d-flex" id="radiodiv">
                            <input
                              type="radio"
                              id="ETD"
                              onChange={(event) => {
                                const obj = { ...advancesearch };
                                obj.sort = event.target.value;

                                setAdvancesearch(obj);
                              }}
                              checked={
                                advancesearch.sort === "ETD" ? true : false
                              }
                              value="ETD"
                            />
                            <label
                              htmlFor="ETD"
                              style={{
                                color:
                                  advancesearch.sort === "ETD" ? "#120b5e" : "",
                              }}
                            >
                              {t("ETD")}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="div-sort" value={advancesearch.order}>
                        <p className="order">{t("OrderBy")} :</p>
                        <div className="sort-option-div">
                          <div className="d-flex" id="radiodiv">
                            <input
                              type="radio"
                              id="ASC"
                              onChange={(event) => {
                                const obj = { ...advancesearch };
                                obj.order = event.target.value;
                                setAdvancesearch(obj);
                              }}
                              checked={
                                advancesearch.order === "ASC" ? true : false
                              }
                              value="ASC"
                            />
                            <label
                              htmlFor="ASC"
                              style={{
                                color:
                                  advancesearch.order === "ASC"
                                    ? "#120b5e"
                                    : "",
                              }}
                            >
                              {t("Ascending")}
                            </label>
                          </div>
                          <div className="d-flex" id="radiodiv">
                            <input
                              type="radio"
                              id="DESC"
                              onChange={(event) => {
                                const obj = { ...advancesearch };
                                obj.order = event.target.value;
                                setAdvancesearch(obj);
                              }}
                              checked={
                                advancesearch.order === "DESC" ? true : false
                              }
                              value="DESC"
                            />

                            <label
                              htmlFor="DESC"
                              style={{
                                color:
                                  advancesearch.order === "DESC"
                                    ? "#120b5e"
                                    : "",
                              }}
                            >
                              {t("Descending")}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="filterby-div">
                        <p>{t("FilterBy")} :</p>

                        <div className="filterby-options">
                          <div className="filterby-div-inner">
                            <div
                              className={
                                advancesearch.mode === "AIR" &&
                                advancesearch.activeA
                                  ? "filter-child-div active-mode"
                                  : "filter-child-div"
                              }
                              id="id1"
                              onClick={() => {
                                const obj = { ...advancesearch };
                                obj.mode = "AIR";
                                obj.activeA = !obj.activeA;
                                setAdvancesearch(obj);
                                setActiveFilter("");
                              }}
                            >
                              <p
                                style={{
                                  color:
                                    advancesearch.mode === "AIR" &&
                                    advancesearch.activeA
                                      ? "#120b5e"
                                      : "",
                                }}
                              >
                                {t("Air")}
                              </p>
                            </div>
                            <div
                              className={
                                advancesearch.mode === "SEA" &&
                                advancesearch.activeS
                                  ? "filter-child-div active-mode"
                                  : "filter-child-div"
                              }
                              id="id2"
                              onClick={() => {
                                const obj = { ...advancesearch };
                                obj.mode = "SEA";
                                obj.activeS = !obj.activeS;
                                setAdvancesearch(obj);
                                setActiveFilter("");
                              }}
                            >
                              <p
                                style={{
                                  color:
                                    advancesearch.mode === "SEA" &&
                                    advancesearch.activeS
                                      ? "#120b5e"
                                      : "",
                                }}
                              >
                                {t("Sea")}
                              </p>
                            </div>
                            <div
                              className={
                                advancesearch.mode === "ROA" &&
                                advancesearch.activeR
                                  ? "filter-child-div active-mode"
                                  : "filter-child-div"
                              }
                              id="id3"
                              onClick={() => {
                                const obj = { ...advancesearch };
                                obj.mode = "ROA";
                                obj.activeR = !obj.activeR;
                                setAdvancesearch(obj);
                                setActiveFilter("");
                              }}
                            >
                              <p
                                style={{
                                  color:
                                    advancesearch.mode === "ROA" &&
                                    advancesearch.activeR
                                      ? "#120b5e"
                                      : "",
                                }}
                              >
                                {t("Land")}
                              </p>
                            </div>
                          </div>
                          <div className="filter-divider"></div>
                          <div className="filterby-div-inner">
                            <div
                              className={
                                (advancesearch.status === "PreLoad" &&
                                  advancesearch.activeP) ||
                                activeFilter === "PreLoad"
                                  ? "filter-child-div active-mode"
                                  : "filter-child-div"
                              }
                              id="id4"
                              onClick={() => {
                                const obj = { ...advancesearch };
                                obj.status = "PreLoad";
                                obj.activeP = !obj.activeP;
                                setAdvancesearch(obj);
                                setActiveFilter("");
                              }}
                            >
                              <p
                                style={{
                                  color:
                                    (advancesearch.status === "PreLoad" &&
                                      advancesearch.activeP) ||
                                    activeFilter === "PreLoad"
                                      ? "#120b5e"
                                      : "",
                                }}
                              >
                                {t("PreLoaded")}
                              </p>
                            </div>
                            <div
                              className={
                                (advancesearch.status === "Loaded" &&
                                  advancesearch.activeL) ||
                                activeFilter === "Loaded"
                                  ? "filter-child-div active-mode"
                                  : "filter-child-div"
                              }
                              id="id5"
                              onClick={() => {
                                const obj = { ...advancesearch };
                                obj.status = "Loaded";
                                obj.activeL = !obj.activeL;
                                setAdvancesearch(obj);
                                setActiveFilter("");
                              }}
                            >
                              <p
                                style={{
                                  color:
                                    (advancesearch.status === "Loaded" &&
                                      advancesearch.activeL) ||
                                    activeFilter === "Loaded"
                                      ? "#120b5e"
                                      : "",
                                }}
                              >
                                {t("Loaded")}
                              </p>
                            </div>
                            <div
                              className={
                                (advancesearch.status === "Arrived" &&
                                  advancesearch.activeAr) ||
                                activeFilter === "Arrived"
                                  ? "filter-child-div active-mode"
                                  : "filter-child-div"
                              }
                              id="id6"
                              onClick={() => {
                                const obj = { ...advancesearch };
                                obj.status = "Arrived";
                                obj.activeAr = !obj.activeAr;
                                setAdvancesearch(obj);
                                setActiveFilter("");
                              }}
                            >
                              <p
                                style={{
                                  color:
                                    (advancesearch.status === "Arrived" &&
                                      advancesearch.activeAr) ||
                                    activeFilter === "Arrived"
                                      ? "#120b5e"
                                      : "",
                                }}
                              >
                                {t("Arrived")}
                              </p>
                            </div>
                          </div>
                          <div className="filter-divider"></div>
                          <div className="filterby-div-inner">
                            <div
                              className={
                                (advancesearch.direction === "IMP" &&
                                  advancesearch.activeI) ||
                                activeFilter === "IMP"
                                  ? "filter-child-div active-mode"
                                  : "filter-child-div"
                              }
                              id="id7"
                              onClick={() => {
                                const obj = { ...advancesearch };
                                obj.direction = "IMP";
                                obj.activeI = !obj.activeI;
                                setAdvancesearch(obj);
                                setActiveFilter("");
                              }}
                            >
                              <p
                                style={{
                                  color:
                                    (advancesearch.direction === "IMP" &&
                                      advancesearch.activeI) ||
                                    activeFilter === "IMP"
                                      ? "#120b5e"
                                      : "",
                                }}
                              >
                                {t("Impo")}
                              </p>
                            </div>

                            <div
                              className={
                                (advancesearch.direction === "EXP" &&
                                  advancesearch.activeE) ||
                                activeFilter === "EXP"
                                  ? "filter-child-div active-mode"
                                  : "filter-child-div"
                              }
                              id="id8"
                              onClick={() => {
                                const obj = { ...advancesearch };
                                obj.direction = "EXP";
                                obj.activeE = !obj.activeE;
                                setAdvancesearch(obj);
                                setActiveFilter("");
                              }}
                            >
                              <p
                                style={{
                                  color:
                                    (advancesearch.direction === "EXP" &&
                                      advancesearch.activeE) ||
                                    activeFilter === "EXP"
                                      ? "#120b5e"
                                      : "",
                                }}
                              >
                                {t("Expo")}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end">
                        <BtnOutline
                          title="Search"
                          onClick={() => onClickSearch()}
                        />
                      </div>
                    </div>
                  ) : null}


                </div>

                {shipmentData && shipmentData.length > 0 ? (
                  shipmentData.map((item, index) => {
                    return (
                      <div
                        className={
                          index === selectedListItem
                            ? "card-mid-selected"
                            : "card-mid "
                        }
                        key={index}
                        onClick={() => handleCardClick(item, index)}
                      >
                        <div className="d-flex">
                          <div className="d-flex card-mid-img">
                            {item.type === "Terminal" ? (
                              <img
                                src={urlResolver("icon/TERMINALWHITE.svg")}
                                alt="Terminal"
                              />
                            ) : item.type === "Shipment" ||
                              item.type === "Transport" ? (
                              item.TransportMode === "SEA" ? (
                                <img
                                  src={urlResolver("icon/icon-ship.svg")}
                                  alt="Sea"
                                />
                              ) : item.TransportMode === "AIR" ? (
                                <img
                                  src={urlResolver("icon/icon-plane-white.svg")}
                                  alt="Air"
                                />
                              ) : item.TransportMode === "ROA" ? (
                                <img
                                  src={urlResolver("icon/truck_color.svg")}
                                  alt="Road"
                                />
                              ) : null
                            ) : item.type === "Cabotage" ? (
                              <img
                                src={urlResolver("icon/carbotagem_transparent.svg")}
                                alt="cabotagem"
                              />) : null}

                            <div className="line  m-2"></div>
                          </div>

                          <div className="order-number-cont">
                            <div>
                              <p className="card-mid-head">
                                {`${t("PONumber")}:`}
                              </p>
                            </div>
                            <div
                              style={{
                                minWidth: "10%",
                                width: "10rem",
                              }}
                            >
                              <p
                                className="card-mid-para"
                                title={item?.OrderReference ?? t("N/A")}
                              >
                                {item?.OrderReference ?? t("N/A")}
                              </p>
                            </div>
                          </div>
                          <div></div>
                        </div>

                        <div className="card-div">
                          <ul
                            style={{
                              paddingLeft: "0rem",
                            }}
                          >
                            <li
                              className={
                                item?.Status === "PreLoaded"
                                  ? "card-mid-list colorPreload"
                                  : item.Status === "Loaded"
                                    ? "card-mid-list colorLoaded"
                                    : item.Status === "Arrived"
                                      ? "card-mid-list colorArrived"
                                      : "card-mid-list"
                              }
                            >
                              {t(item?.Status ?? t("N/A"))}
                              {/* {item?.Status ?? "N/A"} */}
                            </li>
                          </ul>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <Nodata />
                )}
                {(totalCount > shipmentData.length ||
                  (totalCount === 0 && shipmentData.length !== 0)) && (
                  <div className=" d-flex justify-content-center buttonline btn-style">
                    <BtnOutline
                      title={
                        isLoadMore ? (
                          <CircularProgress
                            size="0.7rem"
                            style={{ color: "var(--color-blue)" }}
                          />
                        ) : (
                          t("ShowMore")
                        )
                      }
                      disabled={isLoadMore}
                      onClick={handleShowMore}
                    />
                  </div>
                )}
                {/* {(!loading &&
                  shipmentData.length > 19 &&
                  shipmentData.length % 20 === 0) ||
                shipmentData.length > 19 ? (
                  <div className=" d-flex justify-content-center buttonline btn-style">
                    <BtnOutline
                      title={
                        isLoadMore ? (
                          <CircularProgress
                            size="0.7rem"
                            style={{ color: "var(--color-blue)" }}
                          />
                        ) : (
                          t("ShowMore")
                        )
                      }
                      disabled={isLoadMore}
                      onClick={() => {
                        const counts = count + 1;
                        setCount(counts);
                        setShowMore(true);
                      }}
                    />
                  </div>
                ) : null} */}
              </div>
              <div
                className="col-12  col-lg-9 mid-container d-flex "
                id="left-process-div"
              >
                <Outlet />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default withTranslation()(Process);
